import {
  Box,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  card: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: 8,
    opacity: 1,
  },
  cardHeader: {
    // color: "#646464",
    color: "black",
    fontWeight: 700,
  },
}), { index: 999 });

const PreviewTile = ({ title, text }) => {
  const classes = useStyles();

  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const pad2 = 2;
  const pad1 = 1;
  return (
    <Grid item xs={4} md={2} key={title}>
      <Box
        mr={1}
        p={matches ? pad2 : pad1}
        height={matches ? "auto" : "50px"}
        className={classes.card}
      >
        <Typography noWrap variant={matches ? "body1" : "body1"} gutterBottom>
          {title}
        </Typography>
        <Typography variant={matches ? "h5" : "body2"} gutterBottom>
          {text}
        </Typography>
      </Box>
    </Grid>
  );
};

PreviewTile.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default PreviewTile;
